/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_PoolListDto } from '../models/PagedResultDto_PoolListDto';
import type { Wealthlane_AwardService_Dtos_Common_DropdownDto } from '../models/Wealthlane_AwardService_Dtos_Common_DropdownDto';
import type { Wealthlane_AwardService_Dtos_Pool_BulkPoolOperationDto } from '../models/Wealthlane_AwardService_Dtos_Pool_BulkPoolOperationDto';
import type { Wealthlane_AwardService_Dtos_Pool_BulkPoolResponseDto } from '../models/Wealthlane_AwardService_Dtos_Pool_BulkPoolResponseDto';
import type { Wealthlane_AwardService_Dtos_Pool_CreatePoolDto } from '../models/Wealthlane_AwardService_Dtos_Pool_CreatePoolDto';
import type { Wealthlane_AwardService_Dtos_Pool_PoolDto } from '../models/Wealthlane_AwardService_Dtos_Pool_PoolDto';
import type { Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto } from '../models/Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PoolService {

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Pool_PoolDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPoolPool(
requestBody?: Wealthlane_AwardService_Dtos_Pool_CreatePoolDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Pool_PoolDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/pool/pool',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppPoolPool(
requestBody?: Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Pool_UpdatePoolDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/pool/pool',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Pool_PoolDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPoolPoolById(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Pool_PoolDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/pool/{id}/pool-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_PoolListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPoolPoolList(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_PoolListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/pool/pool-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppPoolPool(
id: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/pool/{id}/pool',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Pool_BulkPoolResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppPoolBulkPoolOperations(
requestBody?: Wealthlane_AwardService_Dtos_Pool_BulkPoolOperationDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_Pool_BulkPoolResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/pool/bulk-pool-operations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_DropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppPoolPoolListForDropdown(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_DropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/pool/pool-list-for-dropdown',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
